import { ITreatmentAssignmentApiModel } from "@app/shared/models/treatment-assignment-api.model";

export interface IVisitSlotSearchRequest {
  startDate: Date;
  endDate: Date;
  treatmentAssignments: ITreatmentAssignmentApiModel[]
  isNewCustomer?: boolean;
}
